import { apiBusSchedBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

export class FontStyleAPI {
    constructor() {
        this.baseUrl = new URL("bussched/fonts/", apiBusSchedBaseURL);
    }

    create(componentId, fontStyle) {
        return API.authenticatedRequest({
            url: new URL(componentId, this.baseUrl),
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(fontStyle)
        });
    }

    update(componentId, fontStyleId, fontStyle) {
        return API.authenticatedRequest({
            url: new URL(`${componentId}/${fontStyleId}`, this.baseUrl),
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(fontStyle)
        });
    }

    delete(componentId, fontStyleId) {
        return API.authenticatedRequest({
            url: new URL(`${componentId}/${fontStyleId}`, this.baseUrl),
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    list(componentId) {
        return API.authenticatedRequest({
            url: new URL(componentId, this.baseUrl),
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    listFonts() {
        return API.authenticatedRequest({
            url: new URL("fonts", this.baseUrl),
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    deleteFont(fontName) {
        return API.authenticatedRequest({
            url: new URL(`${fontName}`, this.baseUrl),
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/bussched/FontStyleAPI.js